"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "esperia": {
    "998be577": [{
      "hkey": "8fe5dfa5",
      "slug": "esperia",
      "name": "Esperia",
      "primary": true,
      "skipSearch": false
    }],
    "badia": [{
      "hkey": "8fe5dfa5",
      "slug": "esperia",
      "name": "Esperia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "477cd77e": [{
      "hkey": "c42cb87e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "roccaguglielma-esperia-superiore": [{
      "hkey": "c42cb87e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "593f0797": [{
      "hkey": "c42cb87e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro-esperia-inferiore": [{
      "hkey": "c42cb87e",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "esperia"
    }]
  }
};
exports["default"] = _default;